import { ViewModel, View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { AttachmentDownloader } from "../attachmentFileDownloader";
import { AttachmentListSelectorViewModel } from "../attachmentListSelector/attachmentListSelector-viewModel";
import { CreatePaymentLicenseView } from "./createPaymentLicense-view"
import { AccountGatewayViewModel } from "./gateways/accountGateway/accountGateway-viewModel";
import { CashGatewayViewModel } from "./gateways/cashGateway/cashGateway-viewModel";
import { ChequeGatewayViewModel } from "./gateways/chequeGateway/chequeGateway-viewModel";
import { DebitGatewayViewModel } from "./gateways/debitGateway/debitGateway-viewModel";
import { IbanGatewayViewModel } from "./gateways/ibanGateway/ibanGateway-viewModel";
import { IGateway, IPaymentInfoProvider, PaymentInfo } from "./gateways/IGateway";
import { translate } from "src/common/utilities";

export class CreatePaymentLicenseViewModel extends ViewModel implements IPopup, IPaymentInfoProvider {
    constructor(parentViewModel: ViewModel, processId: string) {
        super(parentViewModel);
        this.loadById(processId);
        this.requestAttachments = ObservableArray.create<Attachment>();
        this.orderAttachments = ObservableArray.create<Attachment>();
        this.creditAccount = new Account(this);
        this.debtAccount = new Account(this);
        this.attachments = new AttachmentListSelectorViewModel(this);
        this.gateways = ObservableArray.create<IGateway>();
        this.gateways.push(...[
            new CashGatewayViewModel(this),
            new DebitGatewayViewModel(this),
            new IbanGatewayViewModel(this),
            new AccountGatewayViewModel(this),
            new ChequeGatewayViewModel(this)
        ]);
        this.paymentInfo = new PaymentInfo(this);
    }

    closePopup(resultCode: string) { }

    GetDefaultView(): View<ViewModel> {
        return new CreatePaymentLicenseView();
    }

    public getTypeId(): string {
        return "VM-C353EF42-2B9C-4D99-809E-405DBCD4D035"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set status(v: number) { this._status = getAsNumber(v); } public get status(): number { return this._status; } private _status: number;
    public set requestId(v: string) { this._requestId = v; } public get requestId(): string { return this._requestId; } private _requestId: string;
    public set orderId(v: string) { this._orderId = v; } public get orderId(): string { return this._orderId; } private _orderId: string;
    public set licesnseId(v: string) { this._licesnseId = v; } public get licesnseId(): string { return this._licesnseId; } private _licesnseId: string;
    public set processId(v: string) { this._processId = v; } public get processId(): string { return this._processId; } private _processId: string;
    public set requestNo(v: string) { this._requestNo = v; } public get requestNo(): string { return this._requestNo; } private _requestNo: string;
    public set orderNo(v: string) { this._orderNo = v; } public get orderNo(): string { return this._orderNo; } private _orderNo: string;
    public set licenseNo(v: string) { this._licenseNo = v; } public get licenseNo(): string { return this._licenseNo; } private _licenseNo: string;
    public set amount(v: number) { this._amount = getAsNumber(v); } public get amount(): number { return this._amount; } private _amount: number;
    public set personName(v: string) { this._personName = v; } public get personName(): string { return this._personName; } private _personName: string;
    public set requestComment(v: string) { this._requestComment = v; } public get requestComment(): string { return this._requestComment; } private _requestComment: string;
    public set orderComment(v: string) { this._orderComment = v; } public get orderComment(): string { return this._orderComment; } private _orderComment: string;
    public set licenseComment(v: string) { this._licenseComment = v; } public get licenseComment(): string { return this._licenseComment; } private _licenseComment: string;
    public set requestType(v: string) { this._requestType = v; } public get requestType(): string { return this._requestType; } private _requestType: string;
    public set transactionCode(v: string) { this._transactionCode = v; } public get transactionCode(): string { return this._transactionCode; } private _transactionCode: string;
    public set transactionTransferType(v: number) { this._transactionTransferType = getAsNumber(v); } public get transactionTransferType(): number { return this._transactionTransferType; } private _transactionTransferType: number;
    public set transactionId(v: string) { this._transactionId = v; } public get transactionId(): string { return this._transactionId; } private _transactionId: string;
    public set accountingTransaction1Code(v: string) { this._accountingTransaction1Code = v; } public get accountingTransaction1Code(): string { return this._accountingTransaction1Code; } private _accountingTransaction1Code: string;
    public set accountingTransaction2Code(v: string) { this._accountingTransaction2Code = v; } public get accountingTransaction2Code(): string { return this._accountingTransaction2Code; } private _accountingTransaction2Code: string;
    public set accountingTransaction1Id(v: string) { this._accountingTransaction1Id = v; } public get accountingTransaction1Id(): string { return this._accountingTransaction1Id; } private _accountingTransaction1Id: string;
    public set accountingTransaction2Id(v: string) { this._accountingTransaction2Id = v; } public get accountingTransaction2Id(): string { return this._accountingTransaction2Id; } private _accountingTransaction2Id: string;
    public set RequestCreationTime(v: moment.Moment) { this._RequestCreationTime = v; } public get RequestCreationTime(): moment.Moment { return this._RequestCreationTime; } private _RequestCreationTime: moment.Moment;
    public set orderCreationTimw(v: moment.Moment) { this._orderCreationTimw = v; } public get orderCreationTimw(): moment.Moment { return this._orderCreationTimw; } private _orderCreationTimw: moment.Moment;
    public set licenseCreationTime(v: moment.Moment) { this._licenseCreationTime = v; } public get licenseCreationTime(): moment.Moment { return this._licenseCreationTime; } private _licenseCreationTime: moment.Moment;
    public set requestAttachments(v: ObservableArray<Attachment>) { this._requestAttachments = v; } public get requestAttachments(): ObservableArray<Attachment> { return this._requestAttachments; } private _requestAttachments: ObservableArray<Attachment>;
    public set orderAttachments(v: ObservableArray<Attachment>) { this._orderAttachments = v; } public get orderAttachments(): ObservableArray<Attachment> { return this._orderAttachments; } private _orderAttachments: ObservableArray<Attachment>;
    public set creditAccount(v: Account) { this._creditAccount = v; } public get creditAccount(): Account { return this._creditAccount; } private _creditAccount: Account;
    public set debtAccount(v: Account) { this._debtAccount = v; } public get debtAccount(): Account { return this._debtAccount; } private _debtAccount: Account;
    public set attachments(v: AttachmentListSelectorViewModel) { this._attachments = v; } public get attachments(): AttachmentListSelectorViewModel { return this._attachments; } private _attachments: AttachmentListSelectorViewModel;
    public set shallShowCreditAccount(v: boolean) { this._shallShowCreditAccount = v; } public get shallShowCreditAccount(): boolean { return this._shallShowCreditAccount; } private _shallShowCreditAccount: boolean;
    public set gateways(v: ObservableArray<IGateway>) { this._gateways = v; } public get gateways(): ObservableArray<IGateway> { return this._gateways; } private _gateways: ObservableArray<IGateway>;
    public set paymentInfo(v: PaymentInfo) { this._paymentInfo = v; } public get paymentInfo(): PaymentInfo { return this._paymentInfo;} private _paymentInfo: PaymentInfo;
    public set selectedGateway(v: IGateway) {
        v?.initialLoad(this.paymentInfo);
        this._selectedGateway = v;
    } public get selectedGateway(): IGateway { return this._selectedGateway; } private _selectedGateway: IGateway;
    


    async loadById(porcessId: string) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PaymentProcessServices/GetProcessById', {
                Id: porcessId
            });
            this.status = result.Request.Status;
            this.requestId = result.Request.RequestId;
            this.orderId = result.Request.OrderId;
            this.licesnseId = result.Request.LicenseId;
            this.processId = result.Request.ProcessId;
            this.requestNo = result.Request.RequestNo;
            this.orderNo = result.Request.OrderNo;
            this.licenseNo = result.Request.LicenseNo;
            this.amount = result.Request.Amount;
            this.personName = result.Request.PersonName;
            this.requestComment = result.Request.RequestComment;
            this.orderComment = result.Request.OrderComment;
            this.licenseComment = result.Request.LicenseComment;
            this.requestType = result.Request.RequestType;
            this.transactionCode = result.Request.TransactionCode;
            this.transactionTransferType = result.Request.TransactionTransferType;
            this.transactionId = result.Request.TransactionId;
            this.accountingTransaction1Code = result.Request.AccountingTransaction1Code;
            this.accountingTransaction2Code = result.Request.AccountingTransaction2Code;
            this.accountingTransaction1Id = result.Request.AccountingTransaction1Id;
            this.accountingTransaction2Id = result.Request.AccountingTransaction2Id;
            this.RequestCreationTime = result.Request.RequestCreationTime;
            this.orderCreationTimw = result.Request.OrderCreationTime;
            this.licenseCreationTime = result.Request.LicenseCreationTime;
            this.requestAttachments.update(...result.Request.RequestAttachments.map(p => {
                let r = new Attachment(this);
                r.name = p.Name;
                r.id = p.Id;
                return r;
            }));

            this.orderAttachments.update(...result.Request.OrderAttachments.map(p => {
                let r = new Attachment(this);
                r.name = p.Name;
                r.id = p.Id;
                return r;
            }));

            this.creditAccount.accountCode = result.Request.CreditAccount?.AccountCode;
            this.creditAccount.accountId = result.Request.CreditAccount?.AccountId;
            this.creditAccount.accountName = result.Request.CreditAccount?.AccountName;
            this.creditAccount.accountPathName = result.Request.CreditAccount?.AccountPathName;
            if (result.Request.CreditAccount) {
                this.shallShowCreditAccount = true;
                this.creditAccount.detailValues.update(...result.Request.CreditAccount.DetailValues.map(p => {
                    let r = new DetailAndValue(this.creditAccount);
                    r.accountDetailId = p.AccountDetailId;
                    r.valueId = p.ValueId;
                    r.detailId = p.DetailId;
                    r.accountSpecifiedDetailName = p.AccountSpecifiedDetailName;
                    r.detailName = p.DetailName;
                    r.valueCode = p.ValueCode;
                    r.valueName = p.ValueName;
                    return r;
                }));
            }
            else {
                this.shallShowCreditAccount = false;
            }

            this.debtAccount.accountCode = result.Request.DebtAccount.AccountCode;
            this.debtAccount.accountId = result.Request.DebtAccount.AccountId;
            this.debtAccount.accountName = result.Request.DebtAccount.AccountName;
            this.debtAccount.accountPathName = result.Request.DebtAccount.AccountPathName;
            this.debtAccount.detailValues.update(...result.Request.DebtAccount.DetailValues.map(p => {
                let r = new DetailAndValue(this.debtAccount);
                r.accountDetailId = p.AccountDetailId;
                r.valueId = p.ValueId;
                r.detailId = p.DetailId;
                r.accountSpecifiedDetailName = p.AccountSpecifiedDetailName;
                r.detailName = p.DetailName;
                r.valueCode = p.ValueCode;
                r.valueName = p.ValueName;
                return r;
            }));
            this.paymentInfo.AccountNumber = result.Request.PersonPaymentInfo;
            this.paymentInfo.Iban = result.Request.PersonIban;
            this.paymentInfo.CreditCardNumber = result.Request.PersonCreditCardNumber;

        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    closeWindow(message: string) {
        this.tryClose(true, message, translate("createPaymentLicense-viewModel.closePage", {}), translate("createPaymentLicense-viewModel.exit", {}));
    }
    async save() {
        let validationResult: string[] = this.validateInformation();
        if (validationResult.length != 0) {
            await this.messageBoxConfirmWarning(validationResult.join('\r\n'), translate("createPaymentLicense-viewModel.error", {}));
        }
        else {
            try {
                this.isLoading = true;
                let result = await this.selectedGateway.save(this);
                if (result.IsSuccessful) {
                    await this.messageBoxConfirmSuccess(translate("createPaymentLicense-viewModel.documentMessage", { licenseCode: result.LicenseCode, transactionCode: result.TransactionCode }), translate("createPaymentLicense-viewModel.error", {}));
                    this.tryClose(false, 'yes');
                }
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    getBasePaymentInfoDto(): { processId: string; attachments: { id: string; name: string; content: string; }[]; } {
        return {
            processId: this.processId,
            attachments: this.attachments.getAttachments().map(q => {
                return {
                    id: q.id,
                    name: q.name,
                    content: q.content
                };
            })
        };
    }

    validateInformation(): string[] {
        let result: string[] = [];
        if (this.selectedGateway == null) result.push(translate("createPaymentLicense-viewModel.paymentMethod", {}));
        if (this.selectedGateway != null) result.push(...this.selectedGateway.validate());
        return result;
    }
}

export class Attachment extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.downloader = new AttachmentDownloader();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set downloader(v: AttachmentDownloader) { this._downloader = v; } public get downloader(): AttachmentDownloader { return this._downloader; } private _downloader: AttachmentDownloader;
}

export class Account extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.detailValues = ObservableArray.create<DetailAndValue>();
    }

    public set accountId(v: string) { this._accountId = v; } public get accountId(): string { return this._accountId; } private _accountId: string;
    public set accountName(v: string) { this._accountName = v; } public get accountName(): string { return this._accountName; } private _accountName: string;
    public set accountCode(v: string) { this._accountCode = v; } public get accountCode(): string { return this._accountCode; } private _accountCode: string;
    public set accountPathName(v: string) { this._accountPathName = v; } public get accountPathName(): string { return this._accountPathName; } private _accountPathName: string;
    public set detailValues(v: ObservableArray<DetailAndValue>) { this._detailValues = v; } public get detailValues(): ObservableArray<DetailAndValue> { return this._detailValues; } private _detailValues: ObservableArray<DetailAndValue>;

}

export class DetailAndValue extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set accountDetailId(v: string) { this._accountDetailId = v; } public get accountDetailId(): string { return this._accountDetailId; } private _accountDetailId: string;
    public set valueId(v: string) { this._valueId = v; } public get valueId(): string { return this._valueId; } private _valueId: string;
    public set detailId(v: string) { this._detailId = v; } public get detailId(): string { return this._detailId; } private _detailId: string;
    public set accountSpecifiedDetailName(v: string) { this._accountSpecifiedDetailName = v; } public get accountSpecifiedDetailName(): string { return this._accountSpecifiedDetailName; } private _accountSpecifiedDetailName: string;
    public set detailName(v: string) { this._detailName = v; } public get detailName(): string { return this._detailName; } private _detailName: string;
    public set valueCode(v: string) { this._valueCode = v; } public get valueCode(): string { return this._valueCode; } private _valueCode: string;
    public set valueName(v: string) { this._valueName = v; } public get valueName(): string { return this._valueName; } private _valueName: string;

}
